import React from "react";

import { useAiAssessment } from "./hooks";
import * as Styled from "./styles";
import IntroPhase from "./IntroPhase";
import QuestionsPhase from "./QuestionsPhase";
import ResultsPhase from "./ResultsPhase";

const AiAssessment: React.FC = () => {
  const {
    phase,
    currentStep,
    totalSteps,
    answers,
    result,
    currentQuestion,
    handleStart,
    handleAnswer,
    handleNavigate,
    handleRestart
  } = useAiAssessment();

  return (
    <Styled.Wrapper>
      {phase === "intro" && <IntroPhase onStart={handleStart} />}

      {phase === "questions" && (
        <QuestionsPhase
          currentStep={currentStep}
          totalSteps={totalSteps}
          currentQuestion={currentQuestion}
          answers={answers}
          onAnswer={handleAnswer}
          onNavigate={handleNavigate}
        />
      )}

      {phase === "results" && result && (
        <ResultsPhase result={result} onRestart={handleRestart} />
      )}
    </Styled.Wrapper>
  );
};

export default AiAssessment;
